<button primary color="green" [matMenuTriggerFor]="dropdownButton" class="menu-trigger">
    {{text}}
    <app-icon name="chevron_down" />
</button>

<mat-menu #dropdownButton="matMenu" xPosition="after" yPosition="below">
    <ng-content select="app-dropdown-button-option" />
</mat-menu>
